<aside [ngClass]="{
    'w-[64px] sidebar-collapsed': isSlimMode,
    'w-[250px]': !isSlimMode
  }"
  class="block bg-black dark:bg-dark-sidebar no-print transition-all duration-300"
  style="height: calc(100vh - 100px)">
  <div class="flex-1 overflow-hidden p-4 flex flex-col justify-between h-full" style="padding-top: 0px !important;">

    <div class="sidebar-header flex-shrink-0 w-full mb-1">
      <button type="button" class="toggle-button flex items-center w-full cursor-pointer" (click)="toggleSidebar()"
        [class.justify-center]="isSlimMode"
        [matTooltip]="isSlimMode ? 'Expand sidebar' : 'Collapse sidebar'"
        matTooltipPosition="right"
        [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
        [matTooltipShowDelay]="0"
        [matTooltipHideDelay]="0"
        [attr.aria-label]="isSlimMode ? 'Expand sidebar' : 'Collapse sidebar'">
        <lucide-icon [name]="isSlimMode ? 'panel-left-open' : 'panel-left-close'" class="text-white w-5 h-5">
        </lucide-icon>
        <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">Collapse sidebar</span>
      </button>
    </div>

    <nav class="flex flex-col w-full h-full justify-between mt-1 mb-2 min-h-0">
      <div class="flex flex-col flex-shrink-0">
        <div class="sidebar-home flex-shrink-0 w-full">
          <a class="sidebar-item sidebar-item-home flex items-center w-full" (click)="goHome(); $event.preventDefault()"
            [class.justify-center]="isSlimMode"
            [class.active]="isActive('')"
            [matTooltip]="isSlimMode ? 'Home' : ''"
            matTooltipPosition="right"
            [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
            [matTooltipShowDelay]="0"
            [matTooltipHideDelay]="0">
            <lucide-icon name="home" class="text-white w-5 h-5"></lucide-icon>
            <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">Home</span>
          </a>
        </div>


      <div class="category-container">
        <div *ngIf="!isSlimMode" class="sidebar-section-header">
          <lucide-icon name="file-text" class="sidebar-section-icon"></lucide-icon>
          <span class="sidebar-section-title">Access Reports</span>
        </div>
        <div class="category-content-area">
          @for (nav of navigation; track nav.uuid) {
            <div *ngIf="nav.uuid" class="w-full mb-1">
              <a class="sidebar-item flex items-center"
                [class.justify-center]="isSlimMode"
                [class.active]="isActiveReport(nav.uuid)"
                (click)="onReportClick(nav); $event.preventDefault()"
                [matTooltip]="isSlimMode ? nav.menuName : ''"
                matTooltipPosition="right"
                [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
                [matTooltipShowDelay]="0"
                [matTooltipHideDelay]="0">
                <lucide-icon [name]="nav.iconName" class="text-white w-5 h-5"></lucide-icon>
                <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">{{ nav.menuName }}</span>
              </a>
            </div>
          } @empty {
          }
        </div>
      </div>
      </div>

      <div class="flex flex-col flex-shrink-0">

        <div class="category-container">
        <div *ngIf="!isSlimMode" class="sidebar-section-header">
          <lucide-icon name="briefcase" class="sidebar-section-icon"></lucide-icon>
          <span class="sidebar-section-title">PavCon Tools</span>
        </div>
        <div class="category-content-area">
          <a *ngIf="hasRole('pavcon') || hasProjectSummaryAccess" class="sidebar-item flex items-center w-full mb-1"
            [routerLink]="['/projects']"
            [class.justify-center]="isSlimMode"
            [class.active]="isActive('/projects')"
            [matTooltip]="isSlimMode ? 'Projects' : ''"
            matTooltipPosition="right"
            [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
            [matTooltipShowDelay]="0"
            [matTooltipHideDelay]="0">
            <lucide-icon name="notebook-tabs" class="text-white w-5 h-5"></lucide-icon>
            <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">Projects</span>
          </a>

          <a *ngIf="hasRole('pavcon') || hasWritebackHistoryAccess" class="sidebar-item flex items-center w-full mb-1"
            [routerLink]="['/writeback-history']"
            [class.justify-center]="isSlimMode"
            [class.active]="isActive('/writeback-history')"
            [matTooltip]="isSlimMode ? 'Writeback History' : ''"
            matTooltipPosition="right"
            [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
            [matTooltipShowDelay]="0"
            [matTooltipHideDelay]="0">
            <lucide-icon name="history" class="text-white w-5 h-5"></lucide-icon>
            <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">Writeback History</span>
          </a>

          <a *ngIf="hasRole('pavcon')" class="sidebar-item flex items-center w-full mb-1"
            [routerLink]="['/executive-orders']"
            [class.justify-center]="isSlimMode"
            [class.active]="isActive('/executive-orders')"
            [matTooltip]="isSlimMode ? 'Executive Orders' : ''"
            matTooltipPosition="right"
            [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
            [matTooltipShowDelay]="0"
            [matTooltipHideDelay]="0">
            <lucide-icon name="newspaper" class="text-white w-5 h-5"></lucide-icon>
            <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">Executive Orders</span>
          </a>
        </div>
      </div>


      <div class="category-container">
        <div *ngIf="!isSlimMode" class="sidebar-section-header">
          <lucide-icon name="hammer" class="sidebar-section-icon"></lucide-icon>
          <span class="sidebar-section-title">Configuration Tools</span>
        </div>
        <div class="category-content-area">
          <a *ngIf="hasRole('pavcon')" class="sidebar-item flex items-center w-full mb-1"
            [routerLink]="['/dev-panel/reports']"
            [class.justify-center]="isSlimMode"
            [class.active]="isActive('/dev-panel')"
            [matTooltip]="isSlimMode ? 'Admin Panel' : ''"
            matTooltipPosition="right"
            [matTooltipClass]="'sidebar-tooltip mat-tooltip-panel-showing bg-[#2A2A2A]'"
            [matTooltipShowDelay]="0"
            [matTooltipHideDelay]="0">
            <lucide-icon name="folder-cog" class="text-white w-5 h-5"></lucide-icon>
            <span *ngIf="!isSlimMode" class="sidebar-text text-white ml-3 min-w-0">Reports Settings</span>
          </a>
        </div>
      </div>
      </div>
    </nav>
  </div>
</aside>
